module.exports = __webpack_public_path__ + "img/12api_safety_alert.efe5343d.png";